import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/showrooms').reply(200, {

    showrooms: [
        {
            id: uuidv4(),
            showroom: 'Showroom001',
            location: 'Taman ABC',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            showroom: 'Showroom002',
            location: 'Taman EFG',
            contact: '0987654321',
        },
        {
            id: uuidv4(),
            showroom: 'Showroom003',
            location: 'Taman QWE',
            contact: '0987654321',
        },
    ]
});